import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { apiSeasonGet, apiSeasonSave, apiTourConfigurationsGet } from '../../api/api-seasons';
import { TourTypeContext } from '../../contexts/tour-type-context';
import { ButtonSubmit, InputCheckbox, InputSpinner, InputText, PageTitle } from '../common';
import { seasonEditPageActions } from './page-actions';

const SeasonEdit = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [tourConfigurations, setTourConfigurations] = useState([]);
    const { tourTypeId } = useContext(TourTypeContext);
    const history = useHistory();
    const { id } = useParams();

    const formSchema = Yup.object().shape({
        seasonName: Yup.string().required('Required'),
    });

    useEffect(() => {
        const LoadData = async () => {
            const tourConfigurationsResult = await apiTourConfigurationsGet(tourTypeId);
            setTourConfigurations(tourConfigurationsResult);

            const seasonResult = await apiSeasonGet(tourTypeId, id);
            seasonResult.maxGroups = seasonResult.maxGroups || 0;

            tourConfigurationsResult.forEach((config) => {
                const value = seasonResult.tourConfigurations.find((x) => x.tourConfigurationId === config.id)?.max || 0;

                seasonResult[`configuration_${config.id}`] = value;
            });

            setData(seasonResult);

            setLoading(false);
        };

        LoadData();
    }, [tourTypeId, id]);

    return (
        <div className="max-w-screen-lg my-2 sm:m-4 sm:rounded-lg shadow-md bg-white sm:px-4 py-4 md:mx-auto">
            <PageTitle title="Edit Season" actions={seasonEditPageActions} />

            {!loading && (
                <Formik
                    initialValues={data}
                    enableReinitialize
                    validationSchema={formSchema}
                    onSubmit={async (values) => {
                        const tourConfigurationsCounts = [];
                        tourConfigurations.forEach((config) => {
                            tourConfigurationsCounts.push({ id: config.id, max: values[`configuration_${config.id}`] });
                        });

                        await apiSeasonSave(tourTypeId, id, values.seasonName, values.maxGroups, tourConfigurationsCounts, values.isDisabled);

                        history.push('/');
                    }}>
                    {({ isSubmitting }) => (
                        <Form className="px-2 sm:px-0">
                            <div className="grid grid-cols-1 gap-y-2">
                                <InputText name="seasonName" label="Name" />
                                <InputSpinner name="maxGroups" min={0} max={99} label="Max Concurrent Tours" />
                                {tourConfigurations.map((config, key) => (
                                    <InputSpinner key={key} name={`configuration_${config.id}`} min={0} max={99} label={`${config.tourConfigurationName} Max`} />
                                ))}
                                <InputCheckbox name="isDisabled" label="Disabled" />
                            </div>
                            <ButtonSubmit isSubmitting={isSubmitting} className="mt-2" />
                        </Form>
                    )}
                </Formik>
            )}
        </div>
    );
};

export default SeasonEdit;
